import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Hinweis, dass ein Bereich nur im gesicherten Modus erreichbar ist, mit Rücklink
 * zur Übersicht (dort wird der gesicherte Modus entsperrt).
 */
export default function GesichertHinweis({ bereich = 'Dieser Bereich' }) {
  return (
    <div className="mx-auto max-w-md rounded-2xl border border-line bg-paper-soft p-6 text-center">
      <div className="mb-2 text-3xl">🔒</div>
      <h1 className="font-serif text-xl font-semibold text-ink">Gesicherter Modus nötig</h1>
      <p className="mt-2 text-sm text-ink-muted">
        {bereich} ist Teil deiner gesicherten Bereiche. Entsperre den gesicherten Modus
        oben auf der Übersicht, um darauf zuzugreifen.
      </p>
      <Link
        to="/"
        className="mt-4 inline-block rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-500"
      >
        Zur Übersicht
      </Link>
    </div>
  );
}
